import { render, staticRenderFns } from "./SearchFilter.vue?vue&type=template&id=51cb2845&scoped=true&"
import script from "./SearchFilter.vue?vue&type=script&lang=ts&"
export * from "./SearchFilter.vue?vue&type=script&lang=ts&"
import style0 from "./SearchFilter.vue?vue&type=style&index=0&id=51cb2845&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cb2845",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsTooltip: require('/var/www/packages/theme/components/atoms/Tooltip.vue').default,AtomsExpandableList: require('/var/www/packages/theme/components/atoms/ExpandableList.vue').default,AtomsRadioContainer: require('/var/www/packages/theme/components/atoms/RadioComponent/RadioContainer.vue').default,AtomsAccordion: require('/var/www/packages/theme/components/atoms/Accordion.vue').default})
